import { Link } from "react-router-dom";
import { Phone, Youtube, MapPin, Facebook, Instagram } from "lucide-react";
import {
  PHONE_DISPLAY,
  PHONE_TEL,
  WHATSAPP_URL,
  LOCATIONS,
  SOCIAL,
} from "../data/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0a0a0a] text-white">
      <div className="container-x py-20 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="font-serif-display text-3xl md:text-4xl leading-[1.05]">
            DR INDRESH DIXIT
          </div>
          <div className="mt-2 text-[12px] tracking-[0.2em] uppercase text-white/55">
            DM, Gastroenterology, Varanasi
          </div>
          <p className="mt-6 text-white/65 leading-relaxed max-w-md">
            Advanced gastroenterology, hepatology and endoscopy practice in
            Varanasi. Premium diagnostic precision with a calm, patient-first
            approach.
          </p>
          <div className="mt-8 flex items-center gap-3 flex-wrap">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
              data-testid="footer-book-btn"
            >
              Book Appointment
            </a>
            <a
              href={PHONE_TEL}
              className="inline-flex items-center gap-2 text-white/85 hover:text-white text-sm font-semibold"
              data-testid="footer-call-btn"
            >
              <Phone className="h-4 w-4" />
              {PHONE_DISPLAY}
            </a>
          </div>

          <div className="mt-10 flex items-center gap-3">
            <a
              href={SOCIAL.youtube}
              target="_blank"
              rel="noreferrer"
              aria-label="YouTube"
              data-testid="footer-social-youtube"
              className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-white hover:text-black transition-colors"
            >
              <Youtube className="h-4 w-4" />
            </a>
            <a
              href={SOCIAL.facebook}
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
              data-testid="footer-social-facebook"
              className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-white hover:text-black transition-colors"
            >
              <Facebook className="h-4 w-4" />
            </a>
            <a
              href={SOCIAL.instagram}
              target="_blank"
              rel="noreferrer"
              aria-label="Instagram"
              data-testid="footer-social-instagram"
              className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center hover:bg-white hover:text-black transition-colors"
            >
              <Instagram className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <div className="overline !text-white/55">Explore</div>
          <ul className="mt-5 space-y-3 text-[14px] text-white/75">
            <li><Link to="/" data-testid="footer-link-home">Home</Link></li>
            <li><Link to="/about" data-testid="footer-link-about">About Dr. Dixit</Link></li>
            <li><Link to="/symptoms" data-testid="footer-link-symptoms">Symptoms</Link></li>
            <li><Link to="/diseases" data-testid="footer-link-conditions">Conditions</Link></li>
            <li><Link to="/procedures" data-testid="footer-link-procedures">Procedures</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact">Contact &amp; Locations</Link></li>
          </ul>

          <div className="overline !text-white/55 mt-10">Resources</div>
          <ul className="mt-5 space-y-3 text-[14px] text-white/75">
            <li><Link to="/blog" data-testid="footer-link-blog">Blog</Link></li>
            <li><Link to="/videos" data-testid="footer-link-videos">Videos</Link></li>
            <li><Link to="/testimonials" data-testid="footer-link-testimonials">Testimonials</Link></li>
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="overline !text-white/55">Clinics in Varanasi</div>
          <div className="mt-5 space-y-6">
            {LOCATIONS.map((l) => (
              <div key={l.id} data-testid={`footer-location-${l.id}`}>
                <div className="text-white font-semibold text-[15px]">
                  {l.name}
                </div>
                <div className="mt-1 text-white/65 text-[13px] leading-relaxed flex gap-2">
                  <MapPin className="h-3.5 w-3.5 mt-0.5 shrink-0 text-[#7ec3e6]" />
                  <span>{l.address}</span>
                </div>
                <div className="mt-1 text-[12px] text-white/55">
                  {l.days} · {l.hours}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-x py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[12px] text-white/50">
          <div>
            © {new Date().getFullYear()} Dr. Indresh Dixit. All rights reserved.
          </div>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/terms" className="hover:text-white">Terms</Link>
            <Link to="/disclaimer" className="hover:text-white">Disclaimer</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
